<app-pagetitle title="Realizar Orçamento" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

@if (erro403) {
  <app-no-access></app-no-access>
} @else {
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body ps-0 pe-0">
                <ng-stepper #cdkStepper [linear]="!isModoEdicao()" class="cdksteppercontent" (selectionChange)="onStepSelectionChange($event)">
                    <cdk-step [optional]="false" >
                        <ng-template cdkStepLabel>
                            <i class="bx bx-list-ul"></i>
                        </ng-template>
                        @if(cdkStepper.selectedIndex === 0){
                        <div>
                            <div class="text-center mb-4">
                                <h5>Parâmetros | Impostos de Orçamento</h5>
                                <p class="card-title-desc">Realize a configuração das constantes para este orçamento</p>
                            </div>

                            <app-form-parametro-orcamento #formParametro [orcamento]="orcamento" (orcamentoChanged)="onOrcamentoChanged($event)"></app-form-parametro-orcamento>

                            <div class="d-flex justify-content-end mt-3">
                                <button 
                                    type="button" 
                                    class="btn btn-primary" 
                                    [disabled]="!temOrcamentoSalvo()"
                                    (click)="navegarParaOrcamento()"
                                    [title]="!temOrcamentoSalvo() ? 'É necessário salvar os parâmetros do orçamento antes de continuar' : ''"
                                >
                                    Orçamento
                                    <i class="fas fa-arrow-right ms-2"></i>
                                </button>
                            </div>
                        </div>
                        }
                    </cdk-step>

                    <cdk-step [optional]="true">
                        <ng-template cdkStepLabel>
                            <i class="bx bx-book-bookmark"></i>
                        </ng-template>
                        @if(cdkStepper.selectedIndex === 1){
                        <div>
                            <div class="text-center mb-4">
                                <h5>Orçamento</h5>
                                <p class="card-title-desc">Realize o orçamento adicionando itens às respectivas
                                    categorias.</p>
                            </div>

                            <app-table-item-orcamento [gruposItensDto]="orcamentosRecebidos" [orcamento]="orcamento"></app-table-item-orcamento>

                            <!-- wizard-tab -->
                            <div class="d-flex justify-content-between mt-4">
                                <button type="button" class="btn btn-primary" (click)="voltar()">
                                    <i class="fas fa-arrow-left me-2"></i>
                                    Parâmetros
                                </button>
                                <button type="button" class="btn btn-primary" (click)="avancar()">
                                    Totais
                                    <i class="fas fa-arrow-right ms-2"></i>
                                </button>
                            </div>
                        </div>
                        }
                    </cdk-step>

                    <cdk-step [optional]="false">
                        <ng-template cdkStepLabel>
                            <i class="bx bxs-bank"></i>
                        </ng-template>
                        @if(cdkStepper.selectedIndex === 2){
                        <div>
                            <div class="text-center mb-4">
                                <h5>Totalizadores</h5>
                                <p class="card-title-desc">Cofira os valores finais para o orçamento</p>
                            </div>

                            <!--TOTAIS-->
                            <app-totais></app-totais>
                            <!--END-TOTAIS-->

                            <!-- wizard-tab -->
                            <div class="d-flex align-items-start gap-3 mt-4">
                                <button type="button" class="btn btn-primary w-sm" id="prevBtn" (click)="voltar()">
                                    <i class="fas fa-arrow-left me-2"></i>
                                    Orçamento
                                </button>
                            </div>
                        </div>}
                    </cdk-step>

                </ng-stepper>
            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->
</div>
<!-- end row -->
}